/* import __COLOCATED_TEMPLATE__ from './article-management.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();